import { mutateDesign } from './mutators';
import { BuildingDesign } from '@shared/models/design/building-design.model';
import { isEmptyBuildingGeometry } from './storey.helpers';

/**
 * Remove empty storeys while guaranteeing that at least one storey survives
 * in each {@link Building}. Buildings with no drawable footprint keep their
 * full empty stack so add-storey-then-draw can fill every floor.
 * Processes storeys from top to bottom per building.
 * @param design {@link BuildingDesign} snapshot to mutate immutably
 * @returns Either the original design or a new instance with storeys removed
 */
export const removeEmptyStoreys = (design: BuildingDesign): BuildingDesign => {
  const removableIds: string[] = [];

  for (const building of design.buildings) {
    // Keep shapeless placeholder floors until a footprint is drawn (DEV-2576).
    if (isEmptyBuildingGeometry(building)) continue;
    const storeys = building.storeys;
    const buildingRemovableIds: string[] = [];
    for (const storey of storeys.toReversed()) {
      if (storeys.length - buildingRemovableIds.length <= 1) break;
      if (storey.shapes.length === 0) {
        buildingRemovableIds.push(storey.id);
      }
    }
    removableIds.push(...buildingRemovableIds);
  }

  if (!removableIds.length) return design;
  return mutateDesign.storey.remove(design, ...removableIds);
};
